import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import vuetify from './plugins/vuetify'
import http from './http'
import VueNotification from '@kugatsu/vuenotification'
import Vue2Filters from 'vue2-filters'
import VueTheMask from 'vue-the-mask'
import VueAnalytics from 'vue-analytics'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import { esconderPalavras } from './helpers/utils.js'
import { VueMaskDirective } from 'v-mask'
import VueSanitize from "vue-sanitize";
import { isSP, isSPHlg } from "@/helpers/utils";

var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);
Vue.filter('esconderValores', esconderPalavras);
Vue.prototype.$http = http
Vue.use(VueNotification, { timer: 20 })
Vue.use(require('vue-moment'))
Vue.use(Vue2Filters)
Vue.use(VueSanitize);
Vue.use(VueTheMask)
Vue.directive('mascara', VueMaskDirective);

Vue.directive('restrict', {
  bind(el, binding) {
    el.addEventListener('keydown', (e) => {
      // delete, backpsace, tab, escape, enter,
      let special = [46, 8, 9, 27, 13]
      if (binding.modifiers['decimal']) {
        // decimal(numpad), period
        special.push(110, 190)
      }
      // special from above
      if (special.indexOf(e.keyCode) !== -1 ||
        // Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return // allow
      }
      if ((binding.modifiers['alpha']) &&
        // a-z/A-Z
        (e.keyCode >= 65 && e.keyCode <= 90)) {
        return // allow
      }
      if ((binding.modifiers['number']) &&
        // number keys without shift
        ((!e.shiftKey && (e.keyCode >= 48 && e.keyCode <= 57)) ||
          // numpad number keys
          (e.keyCode >= 96 && e.keyCode <= 105))) {
        return // allow
      }
      // otherwise stop the keystroke
      e.preventDefault() // prevent
    }) // end addEventListener
  }
}) // end bind


Vue.use(VueAnalytics, {
  id: 'UA-72959774-11',
  router
})
Vue.component('v-text-field', VTextField)

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: false
})

let boostraped = false;

const bootstrap = () => {
  if(boostraped) return;

  boostraped = true;

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    created() {

    }
  }).$mount('#app');
}

const authWithAmei = async () => {
  const keycloak = new window.Keycloak(isSPHlg ? {
    url: "https://amei.homolog.kubernetes.sebrae.com.br/auth",
    realm: "externo",
    clientId: "cidade-empreendedora"
  } : {
    url: "https://amei.sebrae.com.br/auth",
    realm: "externo",
    clientId: "cidade-empreendedora"
  });

  window.keycloak = keycloak;

  const loginWithAmei = async (user) => {
    const response = await http.post('/api/amei/login', {
      nome: keycloak.tokenParsed.given_name + ' ' + keycloak.tokenParsed.family_name,
      email: keycloak.tokenParsed.email,
      cpf: keycloak.tokenParsed.cpf.replace(/[.\- ]/g, ''),
      ameiid: keycloak.tokenParsed.sid,
    });

    window.ameiUser = user;
    window.spUser = response.data.user;

    bootstrap();
  }

  // iniciar o Keycloak
  keycloak
    .init({
      // checkLoginIframe: false,
      onLoad: 'check-sso',
      // onLoad: 'login-required',
      silentCheckSsoRedirectUri:
        window.location.origin + '/amei-silent-check.html',
    })
    .then(async function () {
      if (!keycloak.tokenParsed) {
        keycloak.login();
      }
    })
    .catch(function (e) {
      console.log(e);
      if (e && e.error === 'login_required') {
        keycloak.login();
      }

      alert('🤯 Erro ao inicializar');
    });

  // function handler() {
  //   if (!keycloak) {
  //     return;
  //   }
  //   console.log('🔏 isAuthenticated', keycloak.authenticated || false);
  //   console.log('🔏 token', keycloak.token || '');
  //   console.log('🔏 tokenInfo', keycloak.tokenParsed || {});
  // }

  // keycloak.onReady = () => {
  //   console.log('😃 pronto');
  //   handler();
  // };
  keycloak.onAuthSuccess = () => {
    loginWithAmei(keycloak.tokenParsed);
  };
  // keycloak.onAuthRefreshSuccess = () => {
  //   console.log('😃 atualização da autenticação com sucesso');
  //   handler();
  // };
  // keycloak.onAuthError = (error) => {
  //   console.log('😖 autenticação falhou', error);
  //   handler();
  // };
  // keycloak.onAuthRefreshError = () => {
  //   console.log('😖 atualização da autenticação falhou');
  //   handler();
  // };
  // keycloak.onAuthLogout = () => {
  //   console.log('👋 fez o logout');
  //   handler();
  // };

  keycloak.onTokenExpired = () => {
    keycloak
      .updateToken(5)
      .catch((e) =>
        console.log(
          '😖 deu ruim ao atualizar o token ou a sessão expirou',
          e,
        ),
      )
  };

  // // redirecionar para o login
  // function loginLogoutAmei() {
  //   if (auth) {
  //     window.keycloak.logout({ redirectUri: 'https://google.com'});
  //     // window.keycloak.logout();
  //     return;
  //   }
  //   window.keycloak.login();
  // }

  // // redirecionar para o cadastro
  // function cadastroAmei() {
  //   if (!auth) {
  //     window.keycloak.login({
  //       action: 'register',
  //     });
  //     return;
  //   }
  //   alert('👍 Usuário já está logado');
  // }
}

const boostrapSP = async () => {
  const keycloakJSUrl = isSPHlg ? "https://amei.homolog.kubernetes.sebrae.com.br/auth/js/keycloak.js" : "https://amei.sebrae.com.br/auth/js/keycloak.js";

  // Inject script keycloak.js if not already injected
  const isInjected = !!document.getElementById('keycloak-js');

  if(isInjected) {
    await authWithAmei();
  } else {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'keycloak-js';
    script.src = keycloakJSUrl;
    script.addEventListener('load', async () => {
      await authWithAmei();
    });

    document.head.appendChild(script);
  }
}

if(isSP) {
  boostrapSP();
} else {
  bootstrap();
}
